import {planePointer} from "../primitives/planePointer";
import store from "../../store";
import {planeLine} from "../primitives/planeLine";
import draw from "tui-image-editor/src/js/ui/template/submenu/draw";
import {planePolygon, planePolygonForShowPlanes, planePolygonForTools} from "../primitives/planePolygon";
import {bus} from "../../vue_bus";
import {sortObjectsByZindex} from "../libs/sortObjectsByZindex";
import {nearPoint} from "../libs/nearPoint";
import {markerPointer} from "../primitives/markerPointer";
import {getPlatbandPoints} from "../libs/getPlatBandPoints";
import {getAdditionalPolygonPoints} from "../primitives/additionalPlane";

export const platbandDrawingTool = function (fabricJS) {
    this.fabricJS = fabricJS;
    this.pointZoneSize = 10;
    this.movingID = null;
    this.movingPosition = null;
    this.oldPointID = null;
    this.activeLine = null;
    this.activeShape = null;
    this.polygon = null;
    this.pointArray = [];
    this.lineDict = {};
    this.dashedLineDict = {};
    this.selectedPointID = null;
    this.isComplete = false;
    this.unsaveChanges = false;
    this.points = [];
    this.sourcePoints = null;
    this.isMoving = false;
    this.mode = 'scaling';
    this.supportPolygons = [];

    this.pointArrayToDict = (pointArray) => {
        let pointDict = {};
        for (let pointID in pointArray) {
            pointDict[parseInt(pointID)+1] = {
                x:pointArray[pointID].position.x,
                y:pointArray[pointID].position.y,
                link: pointArray[pointID].link+1,
            }
        }
        return pointDict;
    };

    this.pointDictToArray = (pointDict) => {
        let pointArray = [];
        for (let pointID in pointDict) {
            pointArray.push({
                x:pointDict[pointID].x,
                y:pointDict[pointID].y,
                link: pointDict[pointID].link-1,
            })
        }
        return pointArray
    };


    this.removeAll = () => {
        this.pointArray.forEach((point)=>{
            this.fabricJS.remove(point.toFabric());
        })
        for (let lineID in this.lineDict) {
            this.fabricJS.remove(this.lineDict[lineID]);
        }
        this.fabricJS.remove(this.polygon);
        // this.pointArray.push(newPoint);

        this.pointArray = [];
    }

    this.drawAll = (pointListIn, skipPoints) => {
        let pointList
        if (pointListIn)
            pointList = pointListIn;
        else {
            pointList = this.pointDictToArray(store.getters["active/POINTS"]);
            this.sourcePoints = this.pointDictToArray(store.getters["active/POINTS"]);
        }
        for (let pointID in pointList) {
            let pointer;
            if (!skipPoints) {
                pointer = new planePointer(pointList[pointID], pointID);
                pointer.toFabric().set({zIndex: 7000});
                pointer.link = parseInt(pointList[pointID].link);
                pointer.dragging(true);
                this.pointArray.push(pointer);
                this.points.push(pointer.position);
                this.fabricJS.add(pointer.toFabric());

            } else {
                this.points[pointID].x = pointList[pointID].x;
                this.points[pointID].y = pointList[pointID].y;
            }
        }
        if (!skipPoints) {
            for (let pointID in this.pointArray) {
                let firstPoint = JSON.parse(JSON.stringify(this.pointArray[this.pointArray[pointID].link].position));
                let secondPoint = JSON.parse(JSON.stringify(this.pointArray[pointID].position));
                let line = new planeLine(firstPoint, secondPoint);
                line.set({
                    zIndex: 4,
                    strokeDashArray: [3, 5],
                    strokeWidth: 0.5,
                });
                this.fabricJS.add(line);
                this.dashedLineDict[this.pointArray[pointID].link] = line;
            }
        }

        this.polygon = new planePolygon(this.points);
        this.polygon.set({
            zIndex: 3,
            evented: false
        });
        this.fabricJS.add(this.polygon);
        for (let pointID in this.points) {
            let line = new planeLine(
                JSON.parse(JSON.stringify(this.points[this.pointArray[pointID].link])),
                JSON.parse(JSON.stringify(this.points[pointID])));
            line.set({
                zIndex: 5,
                isLine: true,
                linkPoint: this.pointArray[pointID].link,
            });
            this.fabricJS.add(line);
            this.lineDict[this.pointArray[pointID].link] = line;
        }
        sortObjectsByZindex(this.fabricJS);

    }

    this.addMovingEvent = () => {
        this.fabricJS.on('object:moving', (event) => {
            // this.movingID
            if (this.isMoving)
                return;

            this.isMoving = true;
            let pointID = parseInt(event.target.pointID);
            let targetPoint = {
                id: event.target.pointID,
                x: event.target.left,
                y: event.target.top
            }

            if (this.mode === 'scaling') {
                let dist = null;
                const getDist = (point1, point2) => Math.sqrt(
                    Math.pow(point1.x - point2.x, 2) +
                    Math.pow(point1.y - point2.y, 2)
                );



                // if (this.movingPosition && this.movingPosition.id == event.target.pointID) {
                //     dist = getDist(this.movingPosition, getPoint(event.target));
                // } else {
                //     this.movingPosition = getPoint(event.target);
                // }

                // console.log(store.getters["active/POINTS"][event.target.pointID])
                // console.log(event);

                let direction = -1;
                let lastDist = getDist(this.sourcePoints[pointID], targetPoint)
                const step = 0.0004;
                let newPoints;
                for (let i = 0; i <= 30; i++) {
                    newPoints = getPlatbandPoints(this.sourcePoints, 1 + step * direction);
                    // console.log(1+step*direction)
                    let newDist = getDist(newPoints[pointID], targetPoint);
                    if (newDist < lastDist) {
                        // console.log("new")
                        this.sourcePoints = newPoints;
                    } else {
                        // console.log("change direction");
                        direction *= -1;
                    }
                }

            } else if (this.mode === 'moving') {
                this.sourcePoints[pointID] = JSON.parse(JSON.stringify(targetPoint));
            } else if (this.mode === 'centering') {
                let deltaX = this.sourcePoints[pointID].x - targetPoint.x;
                let deltaY = this.sourcePoints[pointID].y - targetPoint.y;
                for (let pID in this.sourcePoints) {
                    // if (pointID == pID) {
                    //     this.sourcePoints[pointID].x = targetPoint.x;
                    //     this.sourcePoints[pointID].y = targetPoint.y;
                    // }

                    this.sourcePoints[pID].x -= deltaX;
                    this.sourcePoints[pID].y -= deltaY;
                }
            } else {
                this.isMoving = false;
                return;
            }
            for (let lineID in this.lineDict) {
                this.fabricJS.remove(this.lineDict[lineID]);
            }
            this.fabricJS.remove(this.polygon);
            this.drawAll(this.sourcePoints, true);
            this.unsaveChanges = true;
            this.isMoving = false;
        });
    }


    this.fabricJS.on('mouse:move', (options) => {

    });


    this.destroy = () => {
        bus.$off("AcceptPlaneDrawing");
        bus.$off("changePlatbandToolMode")
        this.fabricJS.off('mouse:over',this.lineOverEvent);
        this.fabricJS.off('mouse:out',this.lineOutEvent);
        this.fabricJS.off('mouse:down',this.lineClickEvent);
    }

    bus.$on("changePlatbandToolMode",  (mode) => {
        this.mode = mode
    });

    bus.$on("AcceptPlaneDrawing", async (callback) => {
        this.unsaveChanges = false;
        if (await store.dispatch("active/IS_COMPLETE")) {
            await store.dispatch('active/UPDATE_PLANE_POINTS', this.pointArrayToDict(this.pointArray));
        } else {
            this.pointArray.forEach((point) => {
                store.dispatch(`active/CREATE_POINT`, Object.assign({link: point.link + 1}, point.position));
                // point.dragging(true);
            })
            if (this.pointArray.length > 2) {
                await store.dispatch("active/IS_COMPLETE", true);
            }
        }
        callback()
    })

    this.onUpdateScale = (scale)=>{
        this.pointArray.forEach((pointer)=>{
            pointer.toFabric().set({
                scaleX: 2/scale,
                scaleY: 2/scale,
            })
        })
        for (let lineID in this.lineDict) {
            this.lineDict[lineID].set({
                strokeWidth: 2 / scale,
            })
        }
        for (let lineID in this.dashedLineDict) {
            this.dashedLineDict[lineID].set({
                strokeWidth: 2 / scale,
            })
        }
        for (let polygonID in this.supportPolygons) {
            this.supportPolygons[polygonID].set({
                strokeWidth: 2 / scale,
            })
        }


        this.pointZoneSize = 18 / scale;
        // console.log(this.pointZoneSize);
        // console.log(scale);
    }

    store.dispatch('active/IS_COMPLETE').then((isComplete) => {
        let planeList = store.getters["active/ALL_PLANES_FROM_PHOTO"];
        for (let planeID in planeList) {
            if (planeID == store.state.route.params.planeID)
                continue
            if (!planeList[planeID].isComplete)
                continue

            planeID = parseInt(planeID);
            let pointList = planeList[planeID].points

            if (!(planeList[planeID].type === "window" || planeList[planeID].type === "door"))
                continue

            // let polygon = planePolygon(this.pointDictToArray(pointList));
            let polygon = planePolygonForShowPlanes(
                pointList,
                planeList[planeID].type,
                1,
                planeID
            );
            polygon.set({
                zIndex: 1,
                strokeDashArray: [4, 5],
                strokeWidth: 0.5,
            })
            this.supportPolygons.push(polygon);
            this.fabricJS.add(polygon);


        }
        // this.isComplete = true;
        this.fabricJS.on('mouse:over',this.lineOverEvent);
        this.fabricJS.on('mouse:out',this.lineOutEvent);
        this.fabricJS.on('mouse:down',this.lineClickEvent);

        this.drawAll();
        this.addMovingEvent();
        }
    )
}
